class ImageHandler {
    constructor(gridItem) {
        // Select the custom element first
        this.gridItem = gridItem;
        const isLandElem = gridItem.querySelector(".grid-product__image-wrap .grid-product__secondary-image is-land");
        this.thumbElem = isLandElem ? isLandElem.querySelector("img") : null;
        this.swatchElems = gridItem.querySelectorAll(".grid-product__colors .color-swatch");

        this.preloadedImages = {}; // Store preloaded images

        if (this.thumbElem && this.swatchElems.length > 0) {
            this.preloadImages(); // Preload variant images
            this.init();
        }
    }

    preloadImages() {
        for (const swatchElem of this.swatchElems) {
            const imageUrl = swatchElem.dataset.variantImage;
            if (imageUrl && !this.preloadedImages[imageUrl]) {
                const img = new Image();
                img.src = imageUrl; // Start loading the image
                this.preloadedImages[imageUrl] = img;
            }
        }
    }

    init() {
        this.gridItem.addEventListener('mouseover', (event) => {
          console.log(event.target);
        });
      
        for (const swatchElem of this.swatchElems) {
            swatchElem.addEventListener('mouseover', () => {
                const newImgSrc = swatchElem.dataset.variantImage;
                if (newImgSrc && this.thumbElem) {
                    this.thumbElem.src = newImgSrc;
                    this.thumbElem.srcset = newImgSrc;
                }
            });
        }
    }
}
(() => {
  if (document.querySelector('.product-recommendations-placeholder')) {
    setTimeout(() => {
      document.querySelector('.product-recommendations-placeholder').querySelectorAll(".product-grid-item").forEach(productItem => new ImageHandler(productItem));
    }, 4000);
  } else {
    document.querySelectorAll(".product-grid-item").forEach(productItem => new ImageHandler(productItem));
  }
})();

